/* eslint-disable indent */
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import Card from "../../../component/card/Card";

const QueryBody = ({ queryDetailsObject }) => {
  return (
    <Card>
      <div className="row mb-2 ">
        <div
          className={
            queryDetailsObject?.queryStatus === "IN-PROGRESS"
              ? "col-md-8 col-xl-8 col-lg-8 text-primary"
              : queryDetailsObject?.queryStatus === "SOLVED"
              ? "col-md-8 col-xl-8 col-lg-8 text-success"
              : "col-md-8 col-xl-8 col-lg-8 text-danger"
          }
        >
          <h3>
            Title: {queryDetailsObject?.queryTitle.toUpperCase()}
          </h3>
        </div>
        <div
          className={
            queryDetailsObject?.queryStatus === "IN-PROGRESS"
              ? "col-md-4 col-xl-4 col-lg-4 text-primary"
              : queryDetailsObject?.queryStatus === "SOLVED"
              ? "col-md-4 col-xl-4 col-lg-4 text-success"
              : "col-md-4 col-xl-4 col-lg-4 text-danger"
          }
        >
          Status: {queryDetailsObject?.queryStatus}
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-md-8 col-xl-8 col-lg-8">
          {queryDetailsObject?.createdBy?.workerFirstName +
            " " +
            queryDetailsObject?.createdBy?.workerSurname}{" "}
          :-{" "}
          <strong>
            {queryDetailsObject?.queryCategory || ""} /{" "}
            {queryDetailsObject?.platformType || ""}
          </strong>
        </div>
        <div className="col-md-4 col-xl-4 col-lg-4">
          Date:{" "}
          {moment(queryDetailsObject?.createdAt).format("DD-MM-YYYY")}
        </div>
        <div className="col-md-8 col-xl-8 col-lg-8">
          <h4>Subject :- {queryDetailsObject?.querySubject}</h4>
          <div className="mb-4">{queryDetailsObject?.queryBody}</div>
        </div>
        <div className="col-md-12 col-xl-12 col-lg-12 mb-3">
          <table>
            <tbody>
              <tr>
                {queryDetailsObject?.queryScreenshots.map(
                  (queryScreenshot, queryScreenshotIndex) => (
                    <td key={queryScreenshotIndex}>
                      <a
                        href={queryScreenshot}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={queryScreenshot}
                          className="img-thumbnail mr-2"
                          style={{
                            height: "300px",
                            width: "200px"
                          }}
                        />
                      </a>
                    </td>
                  )
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Card>
  );
};

QueryBody.propTypes = {
  queryDetailsObject: PropTypes.object.isRequired
};

export default QueryBody;
